import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

// manor
import { Typography } from '@comparethemarketau/manor-typography';
import { Modal } from '@comparethemarketau/manor-modal';

// ctm
import { ProviderLogo } from './provider_logo';

const useStyles = createUseStyles((theme) => ({

    productDescrption: {
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: theme.spacing[8],
        alignItems: 'center'
    },
    productLogo: {
        marginRight: '2.4rem'
    },
    productName: {
        fontSize: theme.fontSize.xl,
        lineHeight: theme.lineHeight.normal,
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.primary800
    },
    productUnderwriterName: {
        fontSize: theme.fontSize.sm,
        lineHeight: theme.lineHeight.normal,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey700
    }
}));

const ProductTermsModal = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { title, visible, handleClose, children, dynamicHeight, providerCode, productUnderwriterName, productName } = props;

    return (
        <Modal
            id={'product-terms-modal'}
            trackingLabel={`Modal for ${title}`}
            overlay
            title={title}
            handleOverlayClick={handleClose}
            handleClose={handleClose}
            visible={visible}
            dynamicHeight={dynamicHeight}
            
        >
            <div className={classes.productDescrption}>
                <ProviderLogo className={classes.productLogo} code={providerCode} />
                <div>
                    <Typography className={classes.productName}>{productName}</Typography>
                    <Typography className={classes.productUnderwriterName}>{productUnderwriterName}</Typography>
                </div>
            </div>
            { children }
        </Modal>
    );
};

ProductTermsModal.propTypes = {
    title: PropTypes.string,
    visible: PropTypes.bool,
    handleClose: PropTypes.func,
    dynamicHeight: PropTypes.bool,

    providerCode: PropTypes.string,
    productUnderwriterName: PropTypes.string,
    productName: PropTypes.string,

    children: PropTypes.node
};

export { ProductTermsModal };
